import {
	CreateSecurityEventDto,
	GetSecurityEventsRes,
	UpdateSecurityEventDto,
} from '@dealstack/shared/lib/generated';
import { makeRequest } from '@dealstack/frontend/shared/dataExchange/ApiLayer/apiLayer.ts';
import { formatUnicorn } from '@dealstack/shared/lib/format/formatUnicorn.ts';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths.ts';
import { HTTP_METHOD } from '@dealstack/shared/lib/common/dataExchange/common.ts';
import * as ApiV1 from '@dealstack/shared/lib/common/dataExchange/apiV1.ts';

export const getSecurityEvents = async (args: unknown) => {
	return makeRequest<ApiV1.Response<GetSecurityEventsRes>>({
		endpoint: API_PATHS.CAP_SECURITY_EVENT_EVENTS_LIST_POST,
		method: HTTP_METHOD.POST,
		body: JSON.stringify(args),
	}).then((response) => response.payload);
};

export const createSecurityEvent = async (
	createSecurityEventDto: CreateSecurityEventDto
): Promise<CreateSecurityEventDto> => {
	const endpoint = formatUnicorn(API_PATHS.CAP_SECURITY_EVENT_CREATE_SECURITY_EVENT_POST, {});
	return makeRequest<ApiV1.Response<CreateSecurityEventDto>>({
		endpoint,
		method: HTTP_METHOD.POST,
		body: JSON.stringify(createSecurityEventDto),
	}).then((response) => response.payload as CreateSecurityEventDto);
};

export const updateSecurityEvent = async (
	updateSecurityEventDto: UpdateSecurityEventDto
): Promise<UpdateSecurityEventDto> => {
	const endpoint = formatUnicorn(API_PATHS.CAP_SECURITY_EVENT_UPDATE_SECURITY_EVENT_POST, {});
	return makeRequest<ApiV1.Response<UpdateSecurityEventDto>>({
		endpoint,
		method: HTTP_METHOD.POST,
		body: JSON.stringify(updateSecurityEventDto),
	}).then((response) => response.payload as UpdateSecurityEventDto);
};

export const deleteSecurityEvent = async (softDeleteSecurityEventDto: string): Promise<string> => {
	const endpoint = formatUnicorn(
		API_PATHS.CAP_SECURITY_EVENT_SOFT_DELETE_SECURITY_EVENT_POST,
		{}
	);
	return makeRequest<string>({
		endpoint,
		method: HTTP_METHOD.POST,
		body: JSON.stringify({ id: softDeleteSecurityEventDto }),
	});
};
